import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn, MDBBtnGroup ,MDBIcon, MDBContainer} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import WarningBox from '../components/WarningBox';


import { toast, ToastContainer} from "mdbreact";



const AddEditUser=(props)=>{

  const useMountEffect = (functionName) => useEffect(functionName, [])

  

       
  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [frm, setValues] = useState({
       code:'',
       username:'',
       password:'123456',
       usertoken: sessionStorage.getItem("msal.uc")
        
  });
  
  
      
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;
      
      setValues({ ...frm, [name]: value });
    }
    else
    {
      setValues({ ...frm, [name]: value });
    }

   

};

      

   
  function submitHandler (event){
        event.preventDefault();
        event.target.className += " was-validated";
        
         saveUser();

  }
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


   

  const loaduserdetails=()=>
  {
    
    Axios.get(props.apiServer + '/loaduserdetails?acode=' + props.usercode ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
         
            setValues({ ...frm,
              code:props.usercode,
              username: res.data.username ,

              
            });   
                  
                  
        }
        else
        {
       
            console.log('No record');
        
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const saveUser=()=> {
    
     const data =frm;
   
     Axios.post(props.apiServer + "/saveUser", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
            setValues({...frm, code : res.data.code});
          props.refreshGrid();
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });
   
 }



 
 const deleteUser=()=>
 {
    const data =frm;

   
     Axios.post(props.apiServer + "/deleteuser", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
        props.refreshGrid();
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });

  
   
        
 }


 const [isAdmin,checkAdmin]=useState(0);

      
 function checkAdminAccess() {
     
 
   Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
    .then(res => {
    
       checkAdmin(0);
       checkAdmin(res.data[0].isadmin);
   
    })
  
    .catch(error => {
     
     console.log(error);
    });  
   
  
  
  
  }

useMountEffect(loaduserdetails);



    return (
        <React.Fragment>
        
           <MDBContainer fluid >

           
            <MDBRow>
                <MDBCol >
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     
                 
                   
                  

    
                    <MDBRow hidden>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.code} 
                            id="code"  
                            label="code" 
                            required
                            
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

         
                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.username} 
                            id="username"  
                            label="Username" 
                            required
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

           
                    <MDBRow className="pb-3">
                            <MDBCol md="10">
                            <div className="input-group">
                                  
                            <input 
                             value={frm.password} 
                             id="password"  
                            type={passwordShown ? "text" : "password"} 
                            className="form-control" 
                            placeholder="Password" 
                            aria-label="Password" 
                            aria-describedby="basic-addon" 
                            required
                            onChange={updateField}
                            />

                            <div className="input-group-prepend">
                              <span className="input-group-text" id="basic-addon">
                              <MDBIcon icon="eye" size="1x" onClick={togglePasswordVisiblity} className="prefix" ></MDBIcon>
                              </span>
                            </div>
                          </div>
                                </MDBCol>
                        </MDBRow>

                    {/* <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.password} 
                            id="password"  
                            label="Password" 
                           type="password"
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow> */}

                  

                   <MDBRow>
                       <MDBCol md="6">
                       <MDBBtn className="blue lighten-1" type="submit">
                        Save
                    </MDBBtn>  {props.usercode==="" ?
                           (<MDBBtn id="cmdClose" className="blue lighten-4 blue-text"  onClick={props.toggleModal}>
                           Close
                       </MDBBtn>):(  
                       <MDBBtn color="danger" onClick={deleteUser}>
                       Delete
                   </MDBBtn>
                      
                       
                    
                    )}
                       </MDBCol>
                       <MDBCol md="6">
                     
                       
                       </MDBCol>
                   </MDBRow>

                   
                  
                    </form>
                  
                </MDBCol>
            </MDBRow>
            </MDBContainer>
            <ToastContainer
            hideProgressBar={true}
            newestOnTop={true}
            autoClose={5000}/>

        
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default AddEditUser
